"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var geometry_1 = require("../diagram/geometry");
var paper_1 = require("../diagram/paper");
var events_1 = require("../viewUtils/events");
var authoringState_1 = require("./authoringState");
var CLASS_NAME = "ontodia-states-widget";
var StatesWidget = /** @class */ (function (_super) {
    tslib_1.__extends(StatesWidget, _super);
    function StatesWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listener = new events_1.EventObserver();
        _this.updateAll = function () { return _this.forceUpdate(); };
        return _this;
    }
    StatesWidget.prototype.componentDidMount = function () {
        this.listenEvents();
    };
    StatesWidget.prototype.componentWillReceiveProps = function () {
        this.listener.stopListening();
        this.listenEvents();
    };
    StatesWidget.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
    };
    StatesWidget.prototype.listenEvents = function () {
        var _this = this;
        this.listener.listen(this.props.editor.model.events, 'elementEvent', function (_a) {
            var key = _a.key, data = _a.data;
            if (data.changeSize || data.changePosition) {
                _this.updateAll();
            }
        });
        this.listener.listen(this.props.editor.model.events, 'linkEvent', function (_a) {
            var key = _a.key, data = _a.data;
            if (data.changeVertices) {
                _this.updateAll();
            }
        });
        this.listener.listen(this.props.editor.model.events, 'changeCells', this.updateAll);
        this.listener.listen(this.props.editor.events, 'changeAuthoringState', this.updateAll);
        this.listener.listen(this.props.editor.events, 'changeTemporaryState', this.updateAll);
    };
    StatesWidget.prototype.calculateLinkPath = function (link) {
        var _a = this.props, editor = _a.editor, view = _a.view;
        var source = editor.model.getElement(link.sourceId);
        var target = editor.model.getElement(link.targetId);
        var route = view.getRouting(link.id);
        var verticesDefinedByUser = link.vertices || [];
        var vertices = route ? route.vertices : verticesDefinedByUser;
        var polyline = geometry_1.computePolyline(source, target, vertices);
        return 'M' + polyline.map(function (_a) {
            var x = _a.x, y = _a.y;
            return x + "," + y;
        }).join(' L');
    };
    StatesWidget.prototype.renderLinksStates = function () {
        var _this = this;
        var editor = this.props.editor;
        return editor.model.links.map(function (link) {
            if (editor.temporaryState.links.has(link.data)) {
                var path = _this.calculateLinkPath(link);
                return (React.createElement("path", { key: link.id, d: path, fill: 'none', stroke: 'grey', strokeWidth: 5, strokeOpacity: 0.5, strokeDasharray: '8 8' }));
            }
            var state = (editor.authoringState.index.links.get(link.data) ||
                editor.authoringState.index.elements.get(link.data.sourceId) ||
                editor.authoringState.index.elements.get(link.data.targetId));
            if (state) {
                var path = _this.calculateLinkPath(link);
                var color = void 0;
                if (state.type === authoringState_1.AuthoringKind.ChangeLink) {
                    color = state.before ? 'blue' : 'green';
                }
                else if (state.type === authoringState_1.AuthoringKind.DeleteLink || state.type === authoringState_1.AuthoringKind.DeleteElement) {
                    color = 'red';
                }
                return (React.createElement("path", { key: link.id, d: path, fill: 'none', stroke: color, strokeWidth: 5, strokeOpacity: 0.5 }));
            }
            return null;
        });
    };
    StatesWidget.prototype.renderElementsStates = function () {
        var editor = this.props.editor;
        return editor.model.elements.map(function (element) {
            var _a = geometry_1.boundsOf(element), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
            if (editor.temporaryState.elements.has(element.iri)) {
                return (React.createElement("rect", { key: element.id, x: x, y: y, width: width, height: height, fill: 'none', stroke: 'grey', strokeWidth: 3, strokeOpacity: 0.7, strokeDasharray: '8 8' }));
            }
            var state = editor.authoringState.index.elements.get(element.iri);
            if (state) {
                var actionClass = CLASS_NAME + "__action";
                var cancelClass = CLASS_NAME + "__cancel";
                var onCancel = function () { return editor.discardChange(state); };
                if (state.type === authoringState_1.AuthoringKind.ChangeElement && !state.before) {
                    return React.createElement("g", { key: element.id },
                        React.createElement("text", { x: x, y: y, dy: '-1ex', pointerEvents: 'all' },
                            React.createElement("tspan", { className: actionClass }, "New"),
                            " [",
                            React.createElement("tspan", { className: cancelClass, onClick: onCancel },
                                React.createElement("title", null, "Revert creation of the element"),
                                "cancel"),
                            "]"));
                }
                else if (state.type === authoringState_1.AuthoringKind.ChangeElement && state.before) {
                    return React.createElement("g", { key: element.id },
                        React.createElement("text", { x: x, y: y, dy: '-1ex', pointerEvents: 'all' },
                            React.createElement("tspan", { className: actionClass }, "Change"),
                            " [",
                            React.createElement("tspan", { className: cancelClass, onClick: onCancel },
                                React.createElement("title", null, "Revert all changes in properties of the element"),
                                "cancel"),
                            "]"));
                }
                else if (state.type === authoringState_1.AuthoringKind.DeleteElement) {
                    var right = x + width;
                    var bottom = y + height;
                    return React.createElement("g", { key: element.id },
                        React.createElement("text", { x: x, y: y, dy: '-1ex', pointerEvents: 'all' },
                            React.createElement("tspan", { className: actionClass }, "Delete"),
                            " [",
                            React.createElement("tspan", { className: cancelClass, onClick: onCancel },
                                React.createElement("title", null, "Revert deletion of the element"),
                                "cancel"),
                            "]"),
                        React.createElement("rect", { x: x, y: y, width: width, height: height, fill: 'white', fillOpacity: 0.5 }),
                        React.createElement("line", { x1: x, y1: y, x2: right, y2: bottom, stroke: 'red' }),
                        React.createElement("line", { x1: right, y1: y, x2: x, y2: bottom, stroke: 'red' }));
                }
                else {
                    throw new Error('Unexpected element status');
                }
            }
            return null;
        });
    };
    StatesWidget.prototype.render = function () {
        var paperTransform = this.props.paperTransform;
        return (React.createElement(paper_1.TransformedSvgCanvas, { paperTransform: paperTransform, style: { overflow: 'visible', pointerEvents: 'none' } },
            this.renderLinksStates(),
            this.renderElementsStates()));
    };
    return StatesWidget;
}(React.Component));
exports.StatesWidget = StatesWidget;
